import { createSlice } from '@reduxjs/toolkit'

import { runsheetStopsAdapter } from '../adapters/runsheetStopsAdapter'

export const initialRunsheetStopState = runsheetStopsAdapter.getInitialState()

export const runsheetStopsSlice = createSlice({
  name: 'stops',
  initialState: initialRunsheetStopState,
  reducers: {
    upsertMultipleRunsheetStops: (state, action) => {
      runsheetStopsAdapter.upsertMany(state, action.payload)
    },
    replaceAllRunsheetStops: (state, action) => {
      runsheetStopsAdapter.setAll(state, action.payload)
    },
  },
})

export const {
  upsertMultipleRunsheetStops,
  replaceAllRunsheetStops,
} = runsheetStopsSlice.actions
